import { styled } from "@linaria/react"

import { ellipsis } from "@/styles/mixins.ts"

export const EllipsisContainer = styled.span<{
  inline?: boolean
}>`
  display: ${props => props.inline ? "inline-grid" : "grid"};
`

export const Ellipsis = styled.span`
  ${ellipsis};
`

export const MultilineEllipsis = styled.div<{
  lines: number
}>`
  display: -webkit-box;
  -webkit-line-clamp: ${props => props.lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`
